import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewEncapsulation
} from '@angular/core';

import * as FileSaver from 'file-saver';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {NotificationService} from '@app/services/notification/notification.service';
import {MatDialog} from '@angular/material/dialog';
import {ConstantsService} from '@app/services/constants/constants.service';
import {NewActivityDialogComponent} from '@components/my-web-desk/my-web-desk-sidebar/sidebar-content/sidebar-content-activity-center/new-activity-modal/new-activity-dialog/new-activity-dialog.component';
import {ActivityService} from '@components/my-web-desk/my-web-desk-sidebar/sidebar-content/sidebar-content-activity-center/activity-service.service';
import {Subscription} from 'rxjs';
import {DateObj} from '@app/interfaces/DateObj';
import {BackendResponse} from '@app/interfaces/backendResponse';
import {FormControl, FormGroup} from '@angular/forms';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'app-new-activity-modal',
    templateUrl: './new-activity-modal.component.html',
    styleUrls: ['./new-activity-modal.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class NewActivityModalComponent implements OnInit, OnDestroy, OnChanges {
  creator = this.constants.creator_id;

  activities = [];
  projects = [];
  assignedTasks = [];
  satnica = [];
  totalActivities = [];  // aktivnosti iz proventuma i iz task managera zajedno

  showLoader = true;
  ind = 0;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()

  })



  @Input() date: DateObj;
  // @Input() start: DateObj;
  // @Input() end:DateObj;
  @Output() outputActivitiesToParent = new EventEmitter<any[]>();
  taskStatusChangeSubscription: Subscription;

  constructor(
    private taskService: TaskService,
    private notifyService: NotificationService,
    public dialog: MatDialog,
    public constants: ConstantsService,
    private activityService: ActivityService,
    private dataPipe: DatePipe

  ) {

    this.taskStatusChangeSubscription = this.taskService.statusInit.subscribe(result => {
      if (result === true) {
        this.ngOnInit();
        this.taskService.statusInit.next(false);
      }
    });
  }

  ngOnDestroy(): void {
    this.taskStatusChangeSubscription.unsubscribe();
  }

  ngOnInit() {
    this.getActivities();
    this.ind = 1;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.date) {
      this.date = changes.date.currentValue;
      this.getActivities();
    }
  }


  open() {
    this.dialog.open(NewActivityDialogComponent, {
      width: '30%',
      height: '70%',
      disableClose: true,
      data: {mode: 'new', data: {date: this.date}}
    })
      .afterClosed().subscribe(() => {
      this.getActivities();
    });
  }



  deleteActivity(activity) {
    this.taskService.deleteActivity(activity._id).subscribe((response: BackendResponse) => {

      if (response.type === 'success') {
        this.getActivities();
        this.notifyService.showSuccess('Uspješno', response.message);
      } else {
        this.notifyService.showError('Greška', response.message);
      }
    }, error => {
    
    });
  }

  getSatnica()
  {
    this.showLoader = true;
    this.totalActivities = [];
    const date = this.date.year + '-' + this.date.month + '-' + this.date.day;
    this.activityService.getSatnica(date).subscribe(async (response) => {
      if (response.type === 'success') {
        this.satnica = response.result;

      } else {
        this.notifyService.showError('Greška', response.message);
      }
    }, error => {
      
    });

  }

    getActivities() {
        this.showLoader = true;
        this.totalActivities = [];
        const date = this.date.year + '-' + this.date.month + '-' + this.date.day;
        this.activityService.getActivities(date).subscribe(async (response) => {
            if (response.type === 'success') {
                let activities: any[] = [];
                activities = response.result;

// ima aktivnosti iz tm, else nema aktivnosti iz tm, a u proventumu su svi redom poredjani
                if (activities.length > 0) {
                    await this.arrangeActivities(activities);
                    this.createActivitiesObjectsForProventum();
                } else {
                    this.showLoader = false;
                    this.createActivitiesObjectsForProventum();
                }


            } else {
                this.notifyService.showError('Greška', response.message);
            }
        }, error => {
            
        });

        this.getSatnica();
    }


    edit(activity) {
        let mode = 'edit';
        if (activity.automatic_activity !== undefined && activity.automatic_activity == true) {
            mode = 'edit_automatic_activity';
            activity.comment = activity.description;
        }

        this.dialog.open(NewActivityDialogComponent, {
            data: {data: activity, mode: mode},
            width: '30%',
            height: '70%',
        }).afterClosed().subscribe((data) => {
            this.getActivities();
        });
    }


    async arrangeActivities(data: any[]) {
        await this.fillBlankTime(data);
        this.totalActivities = this.totalActivities.filter
        ((v, i, a) => a.findIndex(t => (t.start === v.start && t.end === v.end)) === i).reverse();
        this.showLoader = false;
    }

    fillBlankTime = (data: any[]) => {
        this.totalActivities = [];
        return new Promise((resolve, reject) => {

            try {
                data.forEach((item, index) => {
                    item.task = item.task !== undefined && item.task !== '' ? item.task : null;
                    if (index !== data.length - 1) {
                        item.end = item.end == null ? data[index + 1].start : item.end;
                        const kraj_trenutnog = new Date(item.end);
                        const pocetak_sledeceg = new Date(data[index + 1].start);
                        item.from_proventum = item.from_proventum == true;
                        if (kraj_trenutnog < pocetak_sledeceg) {
                            const dateFrom = kraj_trenutnog.getFullYear() + "-" + (kraj_trenutnog.getMonth() + 1) + "-" + kraj_trenutnog.getDate() + " " +
                                (kraj_trenutnog.getHours() < 10 ? '0' : '') + kraj_trenutnog.getHours() + ":" + (kraj_trenutnog.getMinutes() < 10 ? '0' : '') + kraj_trenutnog.getMinutes();
                            const dateTo = pocetak_sledeceg.getFullYear() + "-" + (pocetak_sledeceg.getMonth() + 1) + "-" + pocetak_sledeceg.getDate() + " " +
                                (pocetak_sledeceg.getHours() < 10 ? '0' : '') + pocetak_sledeceg.getHours() + ":" + (pocetak_sledeceg.getMinutes() < 10 ? '0' : '') + pocetak_sledeceg.getMinutes();

                            // provjeravamo da li je proslo radno vrijeme (nakon 16h)
                            let currentDate16 = new Date();
                            currentDate16 = new Date(currentDate16.getFullYear(), currentDate16.getMonth(), currentDate16.getDate(), 16)
                            let type = {
                                "name": "Posao",
                                "value": "Bussiness"
                            };
                            if (kraj_trenutnog > currentDate16 && (index == data.length - 2)) {
                                type = {
                                    "name": "Ostalo",
                                    "value": "Other"
                                };
                            }

                            const x = {
                                type: type,
                                start: dateFrom,
                                end: dateTo,
                                description: '',
                                disabled: false,
                                status: '',
                                event: 'work',
                                color: '#ff97a1',
                                title: '',
                                project_id: null,
                                task_id: '',
                                task: null,
                                automatic_activity: true,
                                activityDuration: this.getDurationBetweenDates(dateFrom, dateTo),
                                from_proventum: false

                            };
                            this.totalActivities.unshift(item);
                            this.totalActivities.unshift(x);
                        } else {
                            this.totalActivities.unshift(item);
                        }

                    } else {
                        this.totalActivities.unshift(item);
                    }
                    this.totalActivities.unshift(data[data.length - 1]);

                    resolve(this.totalActivities);
                });

            } catch (e) {
                reject(e);
            }


        });
    };

    getDurationBetweenDates(dateFrom, dateTo) {
        let date1: any = new Date(dateFrom);
        let date2: any = new Date(dateTo);
        let diffMs = (date2 - date1); // milliseconds between now & Christmas
        let diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
        let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
        let duration = diffHrs > 0 ? diffHrs + " h " + diffMins + " min" : diffMins + " min";
        return (duration);

    }


    // funkcija koja priprema aktivnosti u objekte kakve zahtjeva funkcija na bekendu u Proventumu,
    // kako bi na slanje to parent svi podaci bili spremni
    createActivitiesObjectsForProventum() {
        let activities = [];
        this.totalActivities.forEach((item) => {
            //remove start and end seconds (string)
            let start = item.start.split(' ');
            let end = item.end.split(' ');

            let y = start[1].length == 8 ? start[0] + ' ' + start[1].substring(0, start[1].length - 3) : item.start;
            let z = end[1].length == 8 ? end[0] + ' ' + end[1].substring(0, end[1].length - 3) : item.end;
            let type = {};
            switch (item.event) {
                case ('work' || 'clockIn'):
                    type = {
                        name: 'Posao',
                        value: 'Business'
                    };
                    break;

                case 'break':
                    type = {
                        name: 'Pauza',
                        value: 'Break'
                    };
                    break;
                case 'personal':
                    type = {
                        name: 'Lični izlazak',
                        value: 'Personal'
                    };
                    break;
                case 'other':
                    type = {
                        name: 'Ostalo',
                        value: 'Other'
                    };
                    break;
            }

            let projectName = !item.project_id && !item.project ? '' : item.project.name;

            let x = {
                dateFrom: y,
                dateTo: z,
                description: item.comment == null || item.comment == '' ? '' : item.comment,
                descriptionChecked: 1,
                disabled: false,
                id: "",
                type: type,
                automatic_activity: item.automatic_activity !== undefined,
                project_name: projectName
            };


            activities.push(x);


        });

        this.outputActivitiesToParent.emit(activities);
    }


}
